/* assets/svnty-marquee-clock.js — THE CLOCK (Part24). Loaded by snippets/svnty-marquee-track.liquid wherever a band renders (the home section, the
   rewards hero); guarded so a page with two bands binds once. A {% javascript %} block would only run when its SECTION is on the page (law 131). */
/* THE CLOCK (Part24, owner order): every marquee on the site runs on ONE shared epoch, so the home band and the rewards band
   are always in phase — on any page, after any reload. The track's animation-delay is set to minus the wall-clock's position
   inside the animation period, so the loop lands where every other copy of it is. Reduced motion: untouched (the CSS shows a static line). */
(function () {
  if (window.__svntyMarqueeClock) return; window.__svntyMarqueeClock = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function stamp(track) {
    var band = track.closest('.svnty-marquee') || track.parentElement;
    var secs = parseFloat(getComputedStyle(band).getPropertyValue('--svp-marquee-duration')) || 60;
    var reps = parseFloat(getComputedStyle(track).getPropertyValue('--svp-marquee-reps')) || 1;   /* the group's repeats (svnty-marquee-track): the period is the setting x reps */
    secs = secs * reps;
    /* THE PACE IN SECONDS PER PHRASE (2026-09-26 14:3x: "the same exact order on every screen, the same source and clock, and
       a number I can reason with"): --svp-marquee-spp = the seconds one phrase takes to pass a point. The loop's period = the
       phrases in a group x spp, the same on every screen whatever the type size, so the shared epoch phases every screen to the
       same phrase at the same instant; the pixels per second follow (the group's width over the period) and are printed on the
       track as data-pxps for the eye. */
    var spp = parseFloat(getComputedStyle(band).getPropertyValue('--svp-marquee-spp')) || 0;
    var group = track.querySelector('.svnty-marquee__group');
    if (spp > 0 && group) {
      var n = group.querySelectorAll('.svnty-marquee__text').length || 1;
      secs = n * spp;
      var d = secs.toFixed(2) + 's'; if (track.style.animationDuration !== d) track.style.animationDuration = d;
      var w = group.getBoundingClientRect().width; if (w > 0) track.setAttribute('data-pxps', (w / secs).toFixed(1));
    }
    var period = secs * 1000;
    var delay = (-((Date.now() % period) / 1000)).toFixed(3) + 's';
    if (track.style.animationDelay !== delay) track.style.animationDelay = delay;
  }
  function phase(root) {
    if (reduce) return;
    (root.querySelectorAll ? root : document).querySelectorAll('.svnty-marquee__track').forEach(stamp);
  }
  /* element-driven: a band that renders after this bundle ran (a page's own section, a late block) stamps itself the instant its
     animation starts — the stamp restarts the animation once, guarded by the data flag, so it can never miss a band */
  document.addEventListener('animationstart', function (e) {
    if (reduce || e.animationName !== 'svnty-marquee-scroll') return;
    var track = e.target; if (!track.classList || !track.classList.contains('svnty-marquee__track')) return;
    if (track.dataset.svntyPhased) return; track.dataset.svntyPhased = '1'; stamp(track);
  }, true);
  phase(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { phase(document); });
  document.addEventListener('shopify:section:load', function (e) { phase(e.target || document); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) phase(document); });
  /* the group's width follows the font size, so a resize re-times and re-phases every band (160 ms after the last resize) */
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { phase(document); }, 160); });
})();
